import {BACKEND_URL, BASE_URL_WEB, fetchInit, PrimaryInfo, SecondaryInfo} from "./util";

export const SpotifyLanding = () => {
    onload();
    return (
        <div>
            <PrimaryInfo text={'Logging in...'}/>
            <SecondaryInfo text={'This will take slightly longer if this is your first time.'}/>
        </div>
    );
}

const onload = () => {
    const landing_url = window.location.href
    if (!validateState(landing_url)) {
        // ERROR: INVALID STATE (CSRF ATTACK)
        window.location.href = BASE_URL_WEB;
    }
    const values = storeAuthInfo(landing_url);
    const code = values![0];
    const error = values![1];
    if (error != null) {
        // FAILURE (user did not log in)
        localStorage.removeItem('mm-token');
        window.location.href = BASE_URL_WEB;
    } else {
        // SUCCESS (user logged in)
        if (code == null) {
            sessionStorage.setItem('error', 'code is null');
            window.location.href = BASE_URL_WEB;
        }
        fetch(BACKEND_URL + '/auth/login', fetchInit('login', null, code!))
            .then(response => response.json())
            .then(data => {
                if (data.token === undefined) { // 400 error
                    window.location.href = BASE_URL_WEB;
                    return;
                }
                localStorage.setItem('mm-token', data.token);
                localStorage.setItem('username', data.username);
                localStorage.setItem('display_name', data.displayName);
                localStorage.setItem('email', data.email);
                localStorage.setItem('timestamp', data.timestamp);
                window.location.href = BASE_URL_WEB + '/' + sessionStorage.getItem('route');
            }).catch(error => {
                // Internal Server Error
                sessionStorage.setItem('error', error);
                localStorage.removeItem('mm-token');
                window.location.href = BASE_URL_WEB;
            });
    }
}

const storeAuthInfo = (url: string) => {
    url = url.replace('#', '?');

    const urlParams = new URLSearchParams(new URL(url).search);
    let code = null;
    let error = null;

    if (!urlParams.has('state')) return;
    if (!urlParams.has('error')) {
        code = urlParams.get('code');
        if (code === undefined) code = null;
    } else {
        error = urlParams.get('error');
    }
    return [code, error];
}

const validateState = (url: string) => {
    const urlParams = new URLSearchParams(url);
    const stored_state = sessionStorage.getItem('state');
    if (!urlParams.has('state') || stored_state == null) return false;
    return stored_state === urlParams.get('state');
}